import React from 'react';
import { useSelector } from 'react-redux'
import { HashLink as Link } from 'react-router-hash-link';
import { GlobalStore } from '../../../store';
import User from '../../../models/User';

export default (): JSX.Element | null => {

  const user = useSelector<GlobalStore, User | null>(store => store.user);

  return (
    user?.isAdministrator
      ? <div className="card p-3 mb-3">
          <h2 id="administrator">Administrators</h2>

          <p>
            Administrators are the supreme rulers of Stay A While, with privileges to perform just about anything.
            Their primary purpose is adding new queues and adding teachers for those queues.
          </p>
          <p>
            Everything below is done on the <Link smooth to="/administration">Administration</Link> page.
          </p>

          <h3 id="sendServerMessage">Set server-message</h3>
          <p>
            Click <em>Set server-message</em>, type a message and click <em>Set message</em>. It is shown to
            everyone connected to <em>Stay A While</em> now, and to anyone who connects while it is active —
            handy for forewarning users before an update. Click <em>Remove message</em> in the same window to clear it.
          </p>

          <h3 id="addAdmin">Add an administrator</h3>
          <p>
            Type the username in the <em>Add administrator</em> field and click <em>Add</em>; the user appears
            in the list below. New administrators may have to log out and back in for the privileges to take effect.
          </p>

          <h3 id="removeAdmin">Remove an administrator</h3>
          <p>
            Click the red cross next to the administrator's name; their rights are removed immediately
            (refresh the page if the list doesn't update). There must always be at least one administrator,
            so the last one cannot be removed.
          </p>

          <h3 id="addQueue">Add a queue</h3>
          <p>
            Type the queue name in the <em>Add queue</em> field and click <em>Add</em>; it appears in the list below.
            To remove a queue, see <Link smooth to="/help#removeQueue">Remove queue</Link> under the <em>Teacher</em> section.
          </p>

          <h3>Add or remove teachers and assistants</h3>
          <p>
            See <Link smooth to="/help#addTeacherOrAssistant">
              Add a teacher or assistant
            </Link> and <Link smooth to="/help#removeTeacherOrAssistant">
              Remove a teacher or assistant
            </Link> under the <em>Teacher</em> section.
          </p>

          <h3>Accessing statistics</h3>
          <p>
            See <Link smooth to="/help#statistics">Statistics</Link> under the <em>Teacher</em> section
          </p>
        </div>
        : null
  );
};
